var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-861.000000, -1812.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(861.000000, 1812.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,5 L4.77777778,5 C3.79593822,5 3,5.79593822 3,6.77777778 L3,19.2222222 C3,20.2040618 3.79593822,21 4.77777778,21 L17.2222222,21 C18.2040618,21 19,20.2040618 19,19.2222222 L19,13",
    id: "Path",
    stroke: "#145685",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9226784,3.52798489 C18.6266583,2.82400503 19.7680352,2.82400504 20.4720151,3.52798492 C21.175995,4.23196479 21.175995,5.37334169 20.4720151,6.07732158 L12.3991156,14.1502211 L9,15 L9.8497789,11.6008844 L17.9226784,3.52798489 Z",
    id: "Path",
    stroke: "#145685",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.58a6d049.svg";
export { ForwardRef as ReactComponent };